import _cloneDeep from 'lodash/cloneDeep'
import {
  json as baseJson,
  info as baseInfo,
} from '../../Base/PromoCode_fortuneWheel'
import themeBase from './_themeBase'
import INDEX from './_index'

const info = _cloneDeep(baseInfo)
const json = _cloneDeep(baseJson)
const templateID = info.templateID + INDEX

info.templateID = templateID
info.name = 'Christmas Light' + info.name
json.templateID = templateID
json.theme = _cloneDeep(themeBase.theme)

const colorPalette = {
  white: '#fcf7dc',
  black: '#161a1e',
  customColor: '#1e431a',
}

// Override primary and secondary colors
json.theme.headline.color = colorPalette.customColor // White for headlines
json.theme.text.color = colorPalette.customColor // #e39b85 for general text
json.theme.button.backgroundColor = colorPalette.customColor // #e39b85 for button backgrounds
json.theme.button.color = colorPalette.white // White text on buttons
json.theme.button.borderColor = colorPalette.customColor // #e39b85 border on the wheel
json.theme.voucher.color = colorPalette.white // White text for vouchers
json.theme.voucher.borderColor = colorPalette.customColor // #e39b85 border for vouchers
json.theme.field.color = colorPalette.customColor // #e39b85 for field text
json.theme.field.borderColor = colorPalette.customColor // #e39b85 borders for fields
json.theme.survey.color = colorPalette.customColor // #e39b85 for survey text
json.theme.survey.borderColor = colorPalette.customColor // #e39b85 borders for survey
json.theme.wheel.color = colorPalette.white // White text on the wheel
json.theme.wheel.borderColor = colorPalette.customColor // #e39b85 border on the wheel
json.theme.wheel.backgroundColor = '#b0261c'
json.theme.wheel.secondaryBackgroundColor = colorPalette.customColor
json.theme.checkbox.color = colorPalette.white // #e39b85 for checkbox tick
json.theme.checkbox.borderColor = colorPalette.customColor // #e39b85 borders for checkboxes
json.theme.checkbox.checkboxColor = colorPalette.customColor // #e39b85 background for checkboxes
json.theme.social.color = colorPalette.customColor // #e39b85 for social icons


json.settings = {
  ...json.settings,
  closeButtonColor: '#1e431a',
}

// Apply theme-specific styling overrides
json.styling = {
  ...json.styling,
  backgroundColor: '#fcf7dc',
  backgroundImage: '',
}

// // Modify content items as needed
// json.steps[0].contentItems = json.steps[0].contentItems.map((item) => {
//   if (item.type === 'headline') {
//     item.content.text = 'Black Friday Specials Await!'
//     item.styling.color = 'rgba(255, 255, 255, 1)'
//   }
//   // Add more conditionals for other content item types
//   return item
// })

export { json, info };